import {
  EEntitledEmployeesType,
  INotificationsConfiguration,
  NotificationType,
} from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

export const configurationOptions = [
  {
    id: "absencesVisibleForOthers",
    name: "absencesVisibleForOthers",
    title: "Pokaż nazwę wniosku w kalendarzu",
    description:
      "Po włączeniu inni pracownicy zobaczą w kalendarzu nazwę złożonego wniosku. Gdy opcja jest wyłączona, widoczna jest tylko ogólna informacja o obecności lub nieobecności.",
    disabledByParent: false,
  },
  {
    id: "billInHours",
    name: "billInHours",
    title: "Udostępnij składanie wniosków godzinowych",
    description:
      "W przypadku możliwości przenoszenia zaległych dni na następny okres, nie ma możliwości włączenia składania wniosków godzinowych.",
    disabledByParent: true,
  },
  {
    id: "billInCalendarDays",
    name: "billInCalendarDays",
    title: "Rozliczaj nieobecność w dniach kalendarzowych",
    description:
      "Po włączeniu do liczby dni nieobecności wliczane są także dni wolne od pracy, takie jak weekendy i święta.",
    disabledByParent: true,
  },
  {
    id: "multipleRequestsPerDayAllowed",
    name: "multipleRequestsPerDayAllowed",
    title: "Pozwól złożyć wiele wniosków jednego dnia",
    description:
      "Po włączeniu pracownik będzie mógł złożyć więcej niż jeden wniosek na ten sam dzień.",
    disabledByParent: false,
  },
  {
    id: "modificationAllowed",
    name: "modificationAllowed",
    title: "Pozwól edytować i anulować wniosek",
    description:
      "Po włączeniu pracownik będzie mógł edytować lub anulować złożony wniosek do momentu jego akceptacji lub odrzucenia.",
    disabledByParent: false,
  },
  {
    id: "commentsAllowed",
    name: "commentsAllowed",
    title: "Dodaj pole komentarza",
    description:
      "Po włączeniu pracownik będzie mógł dodać komentarz, który będzie widoczny przy wniosku.",
    disabledByParent: false,
  },
  {
    id: "justificationRequired",
    name: "justificationRequired",
    title: "Wymagaj uzasadnienia wniosku",
    description:
      "Podczas składania wniosku pracownik będzie zobowiązany do podania uzasadnienia nieobecności.",
    disabledByParent: false,
  },
  {
    id: "attachmentRequired",
    name: "attachmentConfiguration.enabled",
    title: "Dodaj możliwość dołączania załączników.",
    description:
      "Podczas składania wniosku pracownik będzie mógł dodać załączniki.",
    disabledByParent: false,
    hasSubOption: true,
    subOption: {
      name: "attachmentConfiguration.required",
      title: "Pole obowiązkowe",
    },
  },
  {
    id: "replacerRequired",
    name: "replacerConfiguration.enabled",
    title: "Dodaj możliwość wskazania zastępstwa",
    description:
      "Podczas składania wniosku pracownik będzie mógł wskazać osobę, która przejmie jego obowiązki na czas nieobecności.",
    disabledByParent: false,
    hasSubOption: true,
    subOption: {
      name: "replacerConfiguration.required",
      title: "Pole obowiązkowe",
    },
  },
];

export const approverOptions = [
  { name: "absenceRequestCreation", label: "Złożeniu wniosku" },
  { name: "absenceRequestEdition", label: "Edycji lub poprawieniu wniosku" },
];

export const superiorOptions = [
  {
    name: "differentApproverAbsenceRequestAutoAcceptation",
    label: "Automatycznej akceptacji wniosku",
  },
  {
    name: "differentApproverAbsenceRequestAcceptation",
    label: "Akceptacji przez pośredniego przełożonego lub administratora HR",
  },
  {
    name: "longAbsenceRequestEndReminder",
    label: "Powrocie po nieobecności dłuższej niż 90 dni",
    helpText:
      "Powiadomienia wysyłane 3 i 30 dni kalendarzowych przed zakończeniem nieobecności do bezpośredniego przełożonego i pracownika działu kadr.",
  },
];

export const employeeOptions = [
  {
    name: "absenceRequestCreation",
    label: "Nowy",
    helpText:
      "Pracownik otrzyma powiadomienie o wniosku złożonym w jego imieniu.",
  },
  {
    name: "absenceRequestAcceptation",
    label: "Zaakceptowany",
  },
  {
    name: "absenceRequestRejection",
    label: "Odrzucony",
  },
  {
    name: "absenceRequestCancellation",
    label: "Anulowany",
  },
  {
    name: "absenceRequestSentForCorrection",
    label: "Zwrócony do poprawy",
  },
  {
    name: "absenceRequestEdition",
    label: "Edytowany prez administratora",
  },
];

export const ahrOptions = [
  {
    name: "longAbsenceRequestEndReminder",
    label: "Powrocie po nieobecności dłuższej niż 90 dni",
    helpText:
      "Powiadomienia wysyłane 3 i 30 dni kalendarzowych przed zakończeniem nieobecności do bezpośredniego przełożonego i pracownika działu kadr.",
  },
];

export const defaultNotificationsConfig: INotificationsConfiguration = {
  approverNotifications: {
    absenceRequestCreation: [],
    absenceRequestEdition: [],
  },
  immediateSuperiorAndApproverNotifications: {
    differentApproverAbsenceRequestAcceptation: [],
    differentApproverAbsenceRequestAutoAcceptation: [],
    longAbsenceRequestEndReminder: [NotificationType.EMAIL],
  },
  employeeNotifications: {
    absenceRequestCreation: [NotificationType.EMAIL],
    absenceRequestAcceptation: [NotificationType.EMAIL],
    absenceRequestRejection: [NotificationType.EMAIL],
    absenceRequestCancellation: [NotificationType.EMAIL],
    absenceRequestSentForCorrection: [NotificationType.EMAIL],
    absenceRequestEdition: [NotificationType.EMAIL],
  },
  ahrNotifications: {
    longAbsenceRequestEndReminder: [NotificationType.EMAIL],
  },
};

export const defaultEntitledEmployees = {
  type: EEntitledEmployeesType.All,
  employmentTypes: [],
  employeeGroups: [],
  organizationUnits: [],
  costPlaces: [],
};
